import { CARD_CATEGORIES } from '../../shared/cardConfig/constants';

// Actions
export const TOGGLE_EDIT_MODE = 'TOGGLE_EDIT_MODE';
export const TOGGLE_ALL_EDIT_MODE = 'TOGGLE_ALL_EDIT_MODE';
export const CLOSE_EDIT_MODE = 'CLOSE_EDIT_MODE';
export const RESET_EDIT_MODE = 'RESET_EDIT_MODE';

export const editInitial = {};

// Reducer
export function editMode(state, action) {
  if (!state) {
    state = editInitial;
  }
  switch (action.type) {
    case RESET_EDIT_MODE:
      return {};
    case TOGGLE_EDIT_MODE:
      return { ...state, [action.payload]: !state[action.payload] };
    case CLOSE_EDIT_MODE:
      return { ...state, [action.payload]: false };
    case TOGGLE_ALL_EDIT_MODE: {
      const editModes = Object.keys(CARD_CATEGORIES).reduce((obj, category) => {
        obj[category] = true;
        return obj;
      }, {});
      return editModes;
    }
    default:
      return state;
  }
}

// Action Creators
export function toggleEditMode(payload) {
  return { type: TOGGLE_EDIT_MODE, payload };
}

export function closeEditMode(payload) {
  return { type: CLOSE_EDIT_MODE, payload };
}

export function resetEditMode() {
  return { type: RESET_EDIT_MODE };
}

export function toggleAllEditMode() {
  return { type: TOGGLE_ALL_EDIT_MODE };
}
